import moment, { Moment } from 'moment';

export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_DISPLAY_FORMAT_DMY = 'DD-MM-YYYY';

/** Takes a javascript date and will convert it to the ISO date format YYYY-MM-DD suitable to send to a server */
export function dateToIsoDateOnly(date?: Date | null): string | null {
	return date ? moment(date).format(ISO_DATE_FORMAT) : null;
}

export function momentToIsoDateOnly(date?: Moment | null): string | null {
	return date ? date.format(ISO_DATE_FORMAT) : null;
}

export function stringToDate(str?: null | string): Date | null {
	if (!str) return null;

	return new Date(str);
}

export function stringToMoment(str?: null | string): Moment | null {
	if (!str) return null;

	return moment(str);
}

export function formatTime(milliseconds: number) {
	const totalSeconds = Math.floor(milliseconds / 1000);
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;
	return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

/** Convert seconds since the start of day to a date object.*/
export const secondsToDate = (seconds: number) => {
	return moment().utc().startOf('day').add(seconds, 'seconds').toDate();
};

/** Convert a date to seconds since the start of a day.*/
export const dateToSeconds = (date: Date) => {
	return moment(date).utc().diff(moment(date).utc().startOf('day'), 'seconds');
};
